import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  getNotes as getNotesPagedEndpoint,
  addNote as addNoteEndpoint,
  updateNote as updateNoteEndpoint,
  addDelivery as addDeliveryEndpoint,
  getDelivery as getDeliveryEndpoint,
  updateDelivery as updateDeliveryEndpoint
} from "../../helpers/fakebackend_helper";

export const getNotesPaged = createAsyncThunk("note/getNotesPaged", async (paginationRequest) => {
  try {
    return getNotesPagedEndpoint(paginationRequest);
  } catch (error) {
    return error;
  }
});

export const addNote = createAsyncThunk("note/addNote", async (note) => {
  try {
    const data = await addNoteEndpoint(note);
    toast.success("Bilješka uspješno dodana", { autoClose: 3000 });
    return data;
  } catch (error) {
      toast.error("Dodavanje bilješke neuspješno.", { autoClose: 3000 });
    return error;
  }
});

export const updateNote = createAsyncThunk("note/updateNote", async (note) => {
    try { 
        const data = await updateNoteEndpoint(note);
        toast.success("Bilješka uspješno ažuriran", { autoClose: 3000 });
        return data;
    }
    catch (error) {
        toast.error("Ažuriranje bilješke neuspješno.", { autoClose: 3000 });
        return error;
    }
});

export const addDelivery = createAsyncThunk("note/addDelivery", async ({deliveryData, parentId}) => {
  try {
    const data = await addDeliveryEndpoint(deliveryData, parentId);
    toast.success("Dostava uspješno dodana", { autoClose: 3000 });
    return data;
  } catch (error) {
    toast.error("Dodavanje dostave neuspješno.", { autoClose: 3000 });
    return error;
  }
});

export const getDelivery = createAsyncThunk("note/getDelivery", async (noteId) => {
  try {
    return getDeliveryEndpoint(noteId);
  } catch (error) {
    toast.error("Učitavanje dostave neuspješno.", { autoClose: 3000 });
    return error;
  }
});

export const updateDelivery = createAsyncThunk("note/updateDelivery", async ({noteId, deliveryData}) => {
  try {
    const data = await updateDeliveryEndpoint(noteId, deliveryData);
    toast.success("Dostava uspješno ažurirana", { autoClose: 3000 });
    return data;
  } catch (error) {
    toast.error("Ažuriranje dostave neuspješno.", { autoClose: 3000 });
    return error;
  }
});